import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "@/resources/requestInfo";
import {INews} from "./types";
import { NEWS_ROUTES } from "./routes";

export const fetchGetNews = createAsyncThunk<INews[]>(
  "getNews/fetchGetNews",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(NEWS_ROUTES.GET_NEWS);
      
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

